import { adviceDtoSchema } from "data/activities/activities.dto.schemas";
import { z } from "zod";

export const visualSupportDtoSchema = z.object({
  id: z.number().nullable().optional(),
  airtableId: z.string().nullable().optional(),
  innizRef: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  premium: z.boolean().nullable().optional(),
  isInniz: z.boolean().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  thumbnail: z.string().nullable().optional(),
  png: z.string().nullable().optional(),
  pdf: z.string().nullable().optional(),
  techniques: z.any().optional(), //techniquesDtoSchema.optional(),
  techniquesTitles: z.array(z.string()).optional(),
  conseil: adviceDtoSchema.nullable().optional(),
});

export const visualSupportsDtoSchema = z.array(visualSupportDtoSchema);
